import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faCodeBranch, faWindowMaximize } from '@fortawesome/fontawesome-free-solid';

function Footer() {
  return (
    <div className='footer-container'>
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              Kamui-RPG
              <i class='fa fa-gamepad' />
            </Link>
          </div>
          <small class='website-rights'>Kamui-RPG © 2022</small>
          <div class='social-icons'>
            <a
              class='social-icon-link youtube'
              href='https://www.youtube.com/channel/UCFYVfALAOV3FVmCh_vA-Iqg'
            >
              <i class='fab fa-youtube' />
            </a>
            <a
                class='social-icon-link twitter'
                href='https://cortona1.com'
            >
                <FontAwesomeIcon icon={faWindowMaximize} />
            </a>
            <a
              class='social-icon-link twitter'
              href='https://github.com/Cortona1'
            >
              <FontAwesomeIcon icon={faCodeBranch} />
            </a>
            <a
              class='social-icon-link twitter'
              href='https://www.linkedin.com/in/cortona1/'
            >
              <i class='fab fa-linkedin' />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;